import React from 'react';

import { QueryStringContext } from 'contexts/QueryStringContext';
import { MetadataContext } from 'contexts/MetadataContext';
import { Dropdown, NavLabel, Row, SubnavButton } from '../styles';
import range from 'lodash/range';
import { VENDOR_TYPES } from 'Details/utils';

const validDimensions = [
	'category',
	'clientCategory',
	VENDOR_TYPES.original,
	'costCentre',
];

const DIMENSION_NAMES = {
	category: 'AP Taxonomy',
	clientCategory: 'Client Taxonomy',
	supplier: 'Vendor',
	harmonizedSupplier: 'Vendor',
	costCentre: 'Cost Center',
};

export class DimensionSelect extends React.Component {
	state = {
		open: false,
	};

	handleChangeOpen = open => {
		this.setState({ open });
	};

	handleChange = (dimension, levels = 1, setQueryStringStateAndPush) => {
		setQueryStringStateAndPush({
			dimensions: range(levels).map(() => dimension),
			measures: undefined,
			detail: undefined,
			showAllCategories: false,
		});
		this.setState({ open: false });
	};

	render() {
		const {
			options,
			shouldDisableOption,
			dimensions,
			showHarmonizedVendors,
			setQueryStringStateAndPush,
		} = this.props;
		const { open } = this.state;
		const list = options
			.filter(item => validDimensions.includes(item.name))
			.filter(item => {
				const filterVendor =
					showHarmonizedVendors === 'true'
						? VENDOR_TYPES.original
						: VENDOR_TYPES.harmonized;

				return item.name !== filterVendor;
			});
		const currentDimension = dimensions ? dimensions[0] : '';
		const currentLabel = DIMENSION_NAMES[currentDimension];
		return (
			<Dropdown
				label={currentLabel}
				hideOpenLabel
				open={open}
				onChangeOpen={this.handleChangeOpen}
			>
				{list.map(({ name, levels }) => {
					const isDisabled = shouldDisableOption && shouldDisableOption(name);

					return (
						<SubnavButton
							key={name}
							title={name}
							disabled={isDisabled}
							onClick={() =>
								this.handleChange(name, levels, setQueryStringStateAndPush)
							}
						>
							<Row>
								<NavLabel
									disabled={isDisabled}
									active={name === currentDimension}
								>
									{DIMENSION_NAMES[name]}
								</NavLabel>
							</Row>
						</SubnavButton>
					);
				})}
			</Dropdown>
		);
	}
}

export default props => (
	<MetadataContext.Consumer>
		{({ metadata }) => (
			<QueryStringContext.Consumer>
				{({
					dimensions,
					showHarmonizedVendors,
					setQueryStringStateAndPush,
				}) => (
					<DimensionSelect
						{...props}
						dimensions={dimensions}
						options={metadata.dimensions}
						showHarmonizedVendors={showHarmonizedVendors}
						setQueryStringStateAndPush={setQueryStringStateAndPush}
					/>
				)}
			</QueryStringContext.Consumer>
		)}
	</MetadataContext.Consumer>
);
